export default __webpack_public_path__ + "static/media/darkMode_logo.97a2697f.svg";